<template>
	<span>
		<pre><span v-if="!root" class="opacity-75">"</span>{{ value }}<span v-if="!root" class="opacity-75">"</span></pre>
	</span>
</template>

<script>
export default {
	name: 'ArgString',
	props: {value: String, root: Boolean},
}
</script>
